(() => {
  if (customElements.get('norifox-listing')) return;
  class NorifoxListing extends HTMLElement {
    connectedCallback() {
      if(this.dataset.searchOnly==='true'){
        const url=new URL(location.href);
        if(url.searchParams.get('type')!=='product'){url.searchParams.set('type','product');location.replace(url.href);return;}
      }
      this.events?.abort();
      this.events = new AbortController();
      this.strings = JSON.parse(this.querySelector('[data-nfx-strings]').textContent);
      this.media = matchMedia('(max-width: 749px)');
      this.addEventListener('click', event => this.click(event), {signal: this.events.signal});
      this.addEventListener('submit', event => this.submit(event), {signal: this.events.signal});
      this.addEventListener('change', event => this.change(event), {signal: this.events.signal});
      this.addEventListener('toggle', event => {
        if (event.target.matches('[data-nfx-filter]') && event.target.open && !this.media.matches) {
          this.querySelectorAll('[data-nfx-filter]').forEach(other => {if (other !== event.target) other.open = false;});
        }
      }, {capture: true, signal: this.events.signal});
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('cancel', event => {if (this.cartPending) event.preventDefault();}, {signal:this.events.signal});
        dialog.addEventListener('close', () => {if (this.opener?.isConnected) this.opener.focus();}, {signal:this.events.signal});
      });
      this.media.addEventListener('change', () => this.positionFilters(), {signal:this.events.signal});
      window.addEventListener('popstate', () => this.update(location.href, 'pop'), {signal:this.events.signal});
      this.positionFilters();
      this.classList.add('nfx-ready');
    }
    disconnectedCallback() {this.events?.abort();this.request?.abort();}
    positionFilters() {
      const form = this.querySelector('[data-nfx-facet-form]');
      if (!form) return;
      const dialog = this.querySelector('.nfx-filter-dialog');
      const destination = this.querySelector(this.media.matches ? '[data-nfx-filter-mount]' : '[data-nfx-filter-home]');
      if (form.parentElement !== destination) {
        if (dialog.open) dialog.close();
        destination.append(form);
        form.querySelectorAll('details').forEach(details => details.open = this.media.matches);
      }
    }
    status(text) {this.querySelector('[data-nfx-status]').textContent = text;}
    formURL(form) {
      const url = new URL(form.action, location.href);
      url.search = '';
      new FormData(form).forEach((value, key) => {if (String(value).trim()) url.searchParams.append(key, value);});
      if(this.dataset.searchOnly==='true')url.searchParams.set('type','product');
      return url;
    }
    validFilters(form) {
      const min = form.querySelector('[name$=".gte"]');
      const max = form.querySelector('[name$=".lte"]');
      if (max) max.setCustomValidity('');
      if (min && max && min.value && max.value && Number(min.value) > Number(max.value)) max.setCustomValidity(this.strings.invalid_price);
      return form.reportValidity();
    }
    click(event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const close = event.target.closest('[data-nfx-close]');
      if (close) {if (!this.cartPending) close.closest('dialog').close();return;}
      const filter = event.target.closest('[data-nfx-filters]');
      if (filter) {this.opener = filter;this.querySelector('.nfx-filter-dialog').showModal();return;}
      const quick = event.target.closest('[data-nfx-quick]');
      if (quick) {
        if (!window.HTMLDialogElement) return;
        event.preventDefault();
        if (this.cartPending) return;
        if (this.uncertain) {location.assign(this.dataset.cartUrl);return;}
        const template = this.querySelector(`[id="${CSS.escape(quick.dataset.nfxQuick)}"]`);
        if (!template) {location.assign(quick.href);return;}
        this.opener = quick;
        const dialog = this.querySelector('.nfx-buy-dialog');
        dialog.querySelector('[data-nfx-buy-mount]').replaceChildren(template.content.cloneNode(true));
        dialog.showModal();
        dialog.querySelector('select').focus();
        return;
      }
      const link = event.target.closest('[data-nfx-nav],[data-nfx-load]');
      if (!link || link.origin !== location.origin) return;
      event.preventDefault();
      if (this.cartPending) {this.status(this.strings.adding);return;}
      this.update(link.href, link.hasAttribute('data-nfx-load') ? 'append' : 'navigate');
    }
    submit(event) {
      if (event.target.matches('.nfx-buy-form')) {event.preventDefault();this.add(event.target);return;}
      if (event.target.matches('[data-nfx-facet-form]')) {
        event.preventDefault();
        if (!this.validFilters(event.target) || this.cartPending) return;
        this.querySelector('.nfx-filter-dialog').close();
        this.update(this.formURL(event.target), 'filter');
      }
    }
    change(event) {
      if (event.target.matches('.nfx-price-inputs input')) event.target.closest('form').querySelectorAll('.nfx-price-inputs input').forEach(input => input.setCustomValidity(''));
      if (event.target.matches('[data-nfx-sort]')) {const form = this.querySelector('[data-nfx-facet-form]');if (!this.cartPending && this.validFilters(form)) this.update(this.formURL(form), 'sort');}
      if (event.target.matches('[data-nfx-variant]')) {
        const option = event.target.selectedOptions[0];
        const dialog = event.target.closest('dialog');
        dialog.querySelector('[data-nfx-variant-price]').textContent = option.dataset.price || '';
        const compare = dialog.querySelector('[data-nfx-variant-compare]');
        compare.textContent = option.dataset.compare || '';compare.hidden = !option.dataset.compare;
        dialog.querySelector('[type="submit"]').disabled = !option.value || option.disabled;
        const image = dialog.querySelector('.nfx-quick-image');
        if (image && option.dataset.image) {image.removeAttribute('srcset');image.src = option.dataset.image;}
      }
    }
    async update(destination, kind) {
      if (this.cartPending) return;
      this.request?.abort();
      const request = this.request = new AbortController();
      const url = new URL(destination, location.href);
      const endpoint = new URL(url);
      endpoint.searchParams.set('section_id', this.dataset.sectionId);
      this.setAttribute('aria-busy','true');
      this.status(this.strings.loading);
      try {
        const response = await fetch(endpoint, {signal:request.signal, credentials:'same-origin'});
        if (!response.ok) throw Error('Section request failed');
        const html = await response.text();
        if (request.signal.aborted) return;
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const next = documentFragment.querySelector('norifox-listing');
        if (!next?.querySelector('.nfx-view')) throw Error('Missing section');
        if (kind === 'append') {
          const grid = this.querySelector('[data-nfx-grid]');
          const items = next.querySelectorAll('[data-nfx-grid] > li');
          if (!grid || !items.length) throw Error('Missing next page');
          const existing = new Set([...grid.children].map(item => item.dataset.nfxItem));
          let first;
          items.forEach(item => {if (!existing.has(item.dataset.nfxItem)) {const node = document.importNode(item,true);first ||= node;grid.append(node);existing.add(item.dataset.nfxItem);}});
          const oldPage = this.querySelector('[data-nfx-pagination]');
          const newPage = next.querySelector('[data-nfx-pagination]');
          if (!newPage || !first) throw Error('Invalid pagination');
          oldPage.replaceWith(document.importNode(newPage,true));
          const page = this.querySelector('[data-nfx-pagination]');
          page.dataset.shown = grid.children.length;
          const shown = this.strings.shown.replace('__count__', String(grid.children.length)).replace('__total__', page.dataset.total);
          page.querySelector('[data-nfx-shown]').textContent = shown;
          this.status(shown);
          first.querySelector('a')?.focus({preventScroll:true});
        } else {
          if (kind !== 'pop') history.pushState({},'',url);
          const replacement = document.importNode(next,true);
          this.replaceWith(replacement);
          replacement.status(replacement.strings.updated);
          if (kind === 'sort') replacement.querySelector('[data-nfx-sort]')?.focus({preventScroll:true});
          else replacement.querySelector('h1')?.focus({preventScroll:true});
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.status(this.strings.load_failed);
          const fallback = document.createElement('a');fallback.href = url.href;fallback.textContent = this.strings.open_page;fallback.className = 'nfx-recovery';
          this.querySelector('[data-nfx-status]').append(' ',fallback);
        }
      } finally {if (!request.signal.aborted && this.isConnected) this.removeAttribute('aria-busy');}
    }
    async add(form) {
      if (this.cartPending || !form.reportValidity()) return;
      if (this.uncertain) {location.assign(this.dataset.cartUrl);return;}
      const id = Number(new FormData(form).get('id'));
      if (!Number.isSafeInteger(id) || id <= 0) return;
      this.cartPending = true;
      const button = form.querySelector('[type="submit"]');
      const error = form.querySelector('.nfx-form-error');
      const check = form.querySelector('.nfx-cart-check');
      const label = button.innerHTML;
      error.hidden = true;check.hidden = true;button.disabled = true;button.textContent = this.strings.adding;
      this.querySelectorAll('[data-nfx-close]').forEach(control => control.disabled = true);
      let confirmedFailure = false;
      try {
        const response = await fetch(this.dataset.cartAddUrl + '.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});
        if (!response.ok) {
          confirmedFailure = response.status >= 400 && response.status < 500;
          const failure = await response.json().catch(() => ({}));
          throw Error(typeof failure.description === 'string' ? failure.description : this.strings.cart_uncertain);
        }
        location.assign(this.dataset.cartUrl);
      } catch (failure) {
        this.uncertain = !confirmedFailure;
        error.textContent = confirmedFailure ? failure.message : this.strings.cart_uncertain;
        error.hidden = false;check.hidden = false;
        button.disabled = this.uncertain;
        button.innerHTML = label;
        this.cartPending = false;
        this.querySelectorAll('[data-nfx-close]').forEach(control => control.disabled = false);
      }
    }
  }
  customElements.define('norifox-listing', NorifoxListing);
})();


if (!customElements.get('nfx-card-gallery')) {
  customElements.define('nfx-card-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const track = this.querySelector('.nfx-gallery-track');
      const buttons = [...this.querySelectorAll('[data-slide]')];
      const slides = [...this.querySelectorAll('.nfx-gallery-slide')];
      if (!track || buttons.length < 2) return;
      const update = () => {
        const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        slides.forEach((slide, i) => slide.tabIndex = i === index ? 0 : -1);
      };
      track.addEventListener('scroll', update, {passive:true, signal});
      buttons.forEach(button => button.addEventListener('click', () => {
        track.scrollTo({left:Number(button.dataset.slide) * track.clientWidth, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, {signal}));
      update();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
